import ReactCrop from "react-image-crop";
import "react-image-crop/dist/ReactCrop.css";
import React, { Component } from "react";
import Img from "react-image";
import iconValider from "../../../../../styles/img/icon-check-white.svg";
const IconValider = () => (
  <Img src={iconValider} className="btn-valid img-fluid" alt="iconPhoto" />
);

export default class UploadPhoto extends Component {
  state = {
    src: null,
    croppedImageUrl: null,
    crop: {
      unit: "%",
      width: 99.9,
      height: 99.9
    },
  };

  onImageLoaded = (image) => {
    this.imageRef = image;
  };

  onCropComplete = (crop) => {
    this.makeClientCrop(crop);
  };

  onCropChange = (crop, percentCrop) => {
    this.setState({ crop });
  };

  async makeClientCrop(crop) {
    if (this.imageRef && crop.width && crop.height) {
      const croppedImageUrl = await this.getCroppedImg(
        this.imageRef,
        crop,
        "newFile.jpeg"
      );
      this.props.getCroppedImage(croppedImageUrl);

      this.setState({ croppedImageUrl });
    }
  }

  getCroppedImg(image, crop, fileName) {
    const canvas = document.createElement("canvas");
    const scaleX = image.naturalWidth / image.width;
    const scaleY = image.naturalHeight / image.height;
    canvas.width = crop.width;
    canvas.height = crop.height;
    const ctx = canvas.getContext("2d");

    ctx.drawImage(
      image,
      crop.x * scaleX,
      crop.y * scaleY,
      crop.width * scaleX,
      crop.height * scaleY,
      0,
      0,
      crop.width,
      crop.height
    );

    return new Promise((resolve, reject) => {
      canvas.toBlob((blob) => {
        if (!blob) {
          console.error("Canvas is empty");
          return;
        }
        blob.name = fileName;
        window.URL.revokeObjectURL(this.fileUrl);
        this.fileUrl = window.URL.createObjectURL(blob);
        resolve(blob);
      }, "image/jpeg");
    });
  }
  componentDidMount() {
    this.setState({
      photo: this.props.photo,
      isUpload: this.props.upload,
    });
  }
  render() {
    const { crop, croppedImageUrl } = this.state;

    return (
      <form>
        <div
          className="tab-pane  show active"
          id="depart-pane"
          role="tabpanel"
          aria-labelledby="depart-tab"
          style={{ overflowY: "auto" }}
        >
          <div className="content" style={{ paddingTop: 5, paddingBottom: 0 }}>
            <div>
             
              {this.props.isUpload && (
                <ReactCrop
                  src={this.props.photo}
                  crop={crop}
                  ruleOfThirds
                  onImageLoaded={this.onImageLoaded}
                  onComplete={this.onCropComplete}
                  onChange={this.onCropChange}
                />
              )}
               <div class="d-flex justify-content-center ">
                <div class="input-file-style mr-3">
                  <input
                    type="file"
                    class="d-none"
                    accept="image/png, image/jpeg,image/bmp"
                    id="add-media"
                    onChange={this.props.onSelectFile}
                  />
                </div>
                <button
                  type="submit"
                  className=" btn-gradient btn-valid "
                  onClick={this.props.uploadPhoto}
                >
                  <IconValider />
                  Valider{" "}
                </button>
              </div>
            </div>
          </div>
        </div>
      </form>
    );
  }
}
